import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { RoleGuard } from './core/guards/role.guard';

export const routes: Routes = [
    { path: 'home', redirectTo: '', pathMatch: 'full' },
    {
        path: '',
        // component: LandingComponent,
        loadComponent: () =>
            import('./pages/landing/landing.component').then(c => c.LandingComponent),
    },
    {
        path: 'auth',
        loadChildren: () => import('./features/auth/auth.routes').then(m => m.authRoutes),
    },
    {
        path: 'features',
        loadComponent: () =>
            import('./pages/landing/features-details/features-details.component').then(
                c => c.FeaturesDetailsComponent
            ),
    },
    {
        path: 'buyer',
        loadChildren: () => import('./features/buyer/buyer.routes').then(c => c.buyerRoutes),
        canActivate: [AuthGuard, RoleGuard],
        data: { roles: ['buyer'] },
        title: 'Buyer | lamainApp',
    },
    {
        path: 'jobber',
        loadChildren: () => import('./features/jobber/jobber.routes').then(c => c.jobberRoutes),
        canActivate: [AuthGuard, RoleGuard],
        data: { roles: ['jober'] },
        title: 'Jobber | lamainApp',
    },

    // Admin routes
    {
        path: 'admin',
        loadChildren: () => import('./features/admin/admin.routes').then(m => m.ADMIN_ROUTES),
        canActivate: [AuthGuard, RoleGuard],
        data: { roles: ['admin'] },
        title: 'Admin Panel',
    },

    {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full',
    },

    {
        path: 'test',
        loadComponent: () =>
            import('./pages/job-platform/job-platform.component').then(c => c.JobPlatformComponent),
    },
    {
        path: 'terms-and-conditions',
        loadComponent: () =>
            import('./pages/terms-conditions/terms-conditions.component').then(
                c => c.TermsConditionsComponent
            ),
    },
    {
        path: 'not-found',
        loadComponent: () =>
            import('./pages/http/not-found/not-found.component').then(m => m.NotFoundComponent),
        title: 'Page Not Found',
    },
    {
        path: 'unauthorized',
        loadComponent: () =>
            import('./pages/http/unauthorized/unauthorized.component').then(
                m => m.UnauthorizedComponent
            ),
        title: 'Unauthorized',
    },
    // Wildcard routeZ
    {
        path: '**',
        redirectTo: '/not-found',
    },
];

//   {
//     path: 'server-error',
//     loadComponent: () => import('./pages/server-error/server-error.component')
//       .then(m => m.ServerErrorComponent),
//     title: 'Server Error'
//   },

// Authentication routes
//   {
//     path: 'auth',
//     loadChildren: () => import('./features/auth/auth.routes').then(m => m.authRoutes),
//     title: 'Authentication'
//   },

// Protected routes - Dashboard (role-based)
//   {
//     path: 'dashboard',
//     loadComponent: () => import('./features/dashboard/components/dashboard/dashboard.component')
//       .then(m => m.DashboardComponent),
//     canActivate: [AuthGuard],
//     title: 'Dashboard'
//   },

// User management routes (accessible by admin and users for their own profile)
//   {
//     path: 'users',
//     loadChildren: () => import('./features/user-management/user-management.routes')
//       .then(m => m.userManagementRoutes),
//     canActivate: [AuthGuard],
//     title: 'User Management'
//   },

// Skills management routes
//   {
//     path: 'skills',
//     loadChildren: () => import('./features/skills/skills.routes').then(m => m.skillsRoutes),
//     canActivate: [AuthGuard],
//     title: 'Skills'
//   },

// Services routes (primarily for jobbers, but buyers can view)
//   {
//     path: 'services',
//     loadChildren: () => import('./features/services/services.routes').then(m => m.servicesRoutes),
//     canActivate: [AuthGuard],
//     title: 'Services'
//   },

// Service requests routes (primarily for buyers, but jobbers can view)
//   {
//     path: 'service-requests',
//     loadChildren: () => import('./features/service-requests/service-requests.routes')
//       .then(m => m.serviceRequestsRoutes),
//     canActivate: [AuthGuard],
//     title: 'Service Requests'
//   },

// Appointments routes (shared by jobbers and buyers)
//   {
//     path: 'appointments',
//     loadChildren: () => import('./features/appointments/appointments.routes')
//       .then(m => m.appointmentsRoutes),
//     canActivate: [AuthGuard],
//     title: 'Appointments'
//   },

// Feedback routes
//   {
//     path: 'feedback',
//     loadChildren: () => import('./features/feedback/feedback.routes').then(m => m.feedbackRoutes),
//     canActivate: [AuthGuard],
//     title: 'Feedback'
//   },

// Litigation routes
//   {
//     path: 'litigation',
//     loadChildren: () => import('./features/litigation/litigation.routes')
//       .then(m => m.litigationRoutes),
//     canActivate: [AuthGuard],
//     title: 'Disputes'
//   },

// Notifications routes
//   {
//     path: 'notifications',
//     loadChildren: () => import('./features/notifications/notifications.routes')
//       .then(m => m.notificationsRoutes),
//     canActivate: [AuthGuard],
//     title: 'Notifications'
//   },

// Search and discovery
//   {
//     path: 'search',
//     loadComponent: () => import('./features/search/components/search/search.component')
//       .then(m => m.SearchComponent),
//     canActivate: [AuthGuard],
//     title: 'Search'
//   },

// Profile routes
//   {
//     path: 'profile',
//     loadChildren: () => import('./features/profile/profile.routes').then(m => m.profileRoutes),
//     canActivate: [AuthGuard],
//     title: 'Profile'
//   },

// Settings routes
//   {
//     path: 'settings',
//     loadChildren: () => import('./features/settings/settings.routes').then(m => m.settingsRoutes),
//     canActivate: [AuthGuard],
//     title: 'Settings'
//   },

// Help and support
//   {
//     path: 'help',
//     loadChildren: () => import('./features/help/help.routes').then(m => m.helpRoutes),
//     title: 'Help & Support'
//   },

// Error pages
